export const getAdPreviewBannerStyles = () => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: '24px 30px 16px 30px',
  },
  branding: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '10px',
  },
  brandingText: {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '20px',
    color: '#3F3F3F',
  },
  innerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '8px',
    marginBottom: '16px',
    gap: '8px',
  },
  'innerContainer-m': {
    flexDirection: 'column',
  },
  'innerContainer-s': {
    flexDirection: 'column',
  },
  sloganContainer: {
    flex: '1',
    '& .banner-title': {
      fontSize: '18px',
      fontWeight: 600,
      lineHeight: '24px',
      marginTop: '0px',
    },
    '& .banner-description': {
      fontSize: '14px',
      lineHeight: '20px',
    },
  },
  adPreviewContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    minHeight: '170px',
    '& .ad-placement-card-preview': {
      minHeight: '140px',
      borderRadius: '12px',
      margin: '0px',
      color: '#fff',
      backgroundColor: '#fff',
      boxShadow: '0px 2px 21.38px 0px #0000001A',
    },
    '& .cropped-image-view': {
      width: '100% !important',
      height: '100% !important',
      '& img': {
        width: '100% !important',
      },
    },

    '& .ResponsiveBingText': {
      width: '305px',
      '& .business-name-with-ads > .multi-line-ellipsis-text-component': {
        minHeight: 48,
      },
    },

    '& .Responsive_Microsoft_Edge_Single_Carousel_178x100': {
      width: '270px',
      '& .text-container': {
        '& .short-headline': {
          fontSize: '16px',
          lineHeight: '14px',
          width: '250px',
        },
      },
    },
  },
  'adPreviewContainer-m': {
    width: '100%',
  },
  'adPreviewContainer-s': {
    width: '100%',
  },
  createCampaignBtn: {
    alignSelf: 'flex-end',
    backgroundColor: '#0C8484',
    border: 'none',
    '&:hover': {
      backgroundColor: '#008B8B',
      border: 'none',
    },
  },
});
